import React from 'react';
import { useSelector } from 'react-redux';
import { TableRow, TableCell, Typography, withStyles } from '@material-ui/core';
import {
    getOwnerReservationTotals,
    getOwnerStripeData,
} from '../../stores/dashboard/selectors';
import styles from './styles';

const OwnerDashboardChartTotalsRow = (props) => {
    const { index } = props;
    const totals = useSelector(getOwnerReservationTotals);
    const stripeData = useSelector(getOwnerStripeData);

    const grossBookings =
        (totals.stripe || 0) + (totals.fuel_comp || 0) + (totals.cash || 0);

    const rowStyle = index % 2 === 1 ? { background: '#F5F5F5' } : {};
    return (
        <TableRow style={rowStyle}>
            <TableCell align="left">
                <Typography
                    className={props.classes.cellTextStyle}
                    align="left"
                    display="block"
                >
                    Total
                </Typography>
            </TableCell>
            <TableCell>
                <Typography
                    className={props.classes.cellTextStyle}
                    align="center"
                >
                    {grossBookings}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography
                    className={props.classes.cellTextStyle}
                    align="center"
                >
                    ${stripeData.revenue || 0}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography
                    className={props.classes.cellTextStyle}
                    align="center"
                >
                    {totals.stripe || 0}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography
                    className={props.classes.cellTextStyle}
                    align="center"
                >
                    {totals.cash || 0}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography
                    className={props.classes.cellTextStyle}
                    align="center"
                >
                    {totals.fuel_comp || 0}
                </Typography>
            </TableCell>
        </TableRow>
    );
};

export default withStyles(styles)(OwnerDashboardChartTotalsRow);
